export default function UpdateMetaDescription(desc) {
    document.getElementById("meta_description").content = desc;
}